
export default () => next => action  => {
  // console.log(action);
  return next(action);
}


// WEBPACK FOOTER //
// ./middleware/logger.js